












import { Vue, Component, Watch } from 'vue-property-decorator';
import BottomBar from '@/components/BottomTabbar.vue';
import OpenAppTip from '@/plugins/WxOpenAppTip';
import { appShare, wxShareInfo, addPv } from '@/common/ts/common';
import { getBaseInfo } from './api';

Vue.use(OpenAppTip);

@Component({
  components: {
    BottomBar,
  },
})
export default class RoutesHolder extends Vue {
  baseInfo = {};
  bottomBarConfig = {
    tabs: [
      { tabName: '资讯中心', tabPath: '/2019FootballBootCamp' },
      {
        tabName: '报名通道',
        tabPath: '/2019FootballBootCamp/Register',
      },
      {
        tabName: '每周一星',
        tabPath: '/2019FootballBootCamp/Info',
      },
    ],
    themeColor: {
      activeBgColor: '#CA1A1A',
      inactiveBgColor: '#1655A4',
    },
  };
  @Watch('$route', {
    immediate: true,
  })
  onRouteChange(to: any, from: any) {
    if (to.name === 'FootballBootCampRegister' && !window.udid) {
      this.$openAppTip();
    }
  }
  async created() {
    const res = await getBaseInfo();
    this.baseInfo = res.data;
    appShare({
      title: '上游·天才足球青训营',
      url: window.location.href,
      subtitle: '快来报名获得免费训练的资格吧。',
      classId: -1,
      id: -1,
      type: 3,
      image:
        'https://image2.cqcb.com/d/file/topics/activity/2019-10-23/1571824500476banner.jpg',
    });
    wxShareInfo({
      title: '上游·天才足球青训营',
      subtitle: '快来报名获得免费训练的资格吧',
      link: window.location.href,
      image:
        'https://image2.cqcb.com/d/file/topics/activity/2019-10-23/1571824500476banner.jpg',
    });
    this.$addPv((res as any).data.activityId);
  }
}
